<template>
  <div class="services-tab">
    <b-tabs content-class="mt-3">
      <b-tab
        :title="servcat.title"
        :active="$route.query.type==servcat.title"
        v-for="(servcat, index) in data.servicescat"
        :key="index"
        @click="tabChange(servcat.title), defScroll(index)"
        :id="`el${index}`"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
            lg="4"
            v-for="(serv, servindex) in servcat.service"
            :key="servindex"
          >
            <div class="tab-item position-relative">
              <router-link :to="serv.url.replace('/api', '')" class="stretched-link" tag="a"></router-link>
              <div class="image-container">
                <div class="image-container-hover"></div>
                <img class="image-container-img" :src="serv.shortinfo.img.url" alt />
              </div>
              <div class="content d-flex flex-column justify-content-between align-items-start">
                <div class="d-flex justify-content-center align-items-center">
                  <h3 class="content-ttl">{{serv.title}}</h3>
                </div>
                <!-- <p class="content-description">{{serv.shortinfo.text}}</p> -->
                <div class="content-button d-flex justify-content-center align-items-center">
                  <p>Перейти к услуге</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path d="M2 11V9H14L10 5L11 3L18 10L11 17L10 15L14 11H2Z" fill="#ADADAD" />
                  </svg>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data() {
    return {
      data: {}
    };
  },
  beforeMount() {
    axios
      .get(`${this.$root.routLink}${this.$route.path}?ajax&act=services`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
      });
  },
  mounted() {},
  beforeRouteUpdate(to, from, next) {},
  methods: {
    tabChange(type) {
      this.$router.push(`${this.$route.path}?type=${type}`);
    },
    defScroll(id) {
      const cont = document.querySelector('.nav-tabs');
      const el = document.getElementById(`el${id}___BV_tab_button__`);
      const offset = el.offsetLeft;
      cont.scrollLeft = offset;
    },
  },
};
</script>

<style lang="scss">
.services-tab {
  .nav-tabs {
    overflow: scroll;

    /* width */
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background: transparent;
    }

    /* Track */
    &::-webkit-scrollbar-track {
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
    }
  }

  .nav-tabs {
    border-bottom: 2px solid #dcdcdc;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;

    .nav-item {
      .nav-link {
        color: #626262;
        font-weight: 500;
        font-size: 16px;
        line-height: 110%;
        border: none;
        background-color: $bg2Color;

        &.active {
          color: $mainFontColor;
          border-bottom: 4px solid $activeColor;
        }
      }
    }
  }

  .tab-item {
    background-color: #ffffff;
    border-radius: 6px;
    margin-bottom: 30px;
    height: 300px;
    transition: all 0.5s ease-in-out;

    .image-container {
      height: 130px;
      position: relative;
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
        border-radius: 6px 6px 0 0;
      }

      &-img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        @media only screen and (max-width: $sm),
          only screen and (max-device-width: $sm) {
          border-radius: 6px 6px 0 0;
        }
      }

      .image-container-hover {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 0;
        background: linear-gradient(
          263.54deg,
          rgba(0, 166, 93, 0.7) 46.68%,
          rgba(0, 166, 93, 0.7) 65.58%,
          rgba(0, 166, 93, 0.7) 85.35%
        );
        opacity: 0;
        transition: all 0.5s ease-in-out;
      }
    }

    .content {
      padding: 20px 15px;
      height: 170px;
      &-ttl {
        font-weight: 700;
        font-size: 18px;
        line-height: 110%;
        color: $mainFontColor;
        /*margin-bottom: 15px;*/
        transition: all 0.5s ease-in-out;
        @media only screen and (max-width: $sm),
          only screen and (max-device-width: $sm) {
          font-size: 22px;
        }
      }

      &-icon {
        width: 40px;
        margin-right: 10px;
      }

      &-description {
        font-size: 14px;
        line-height: 120%;
        color: $mainFontColor;
        margin-bottom: 15px;
      }

      /*
								&-serv {
									margin-bottom: 15px;
									
									&-name {
										font-weight: 700;
										font-size: 16px;
										line-height: 110%;
										text-decoration-line: underline;
										color: $activeColor;
										margin-left: 10px;
									}
								}
				*/

      &-button {
        border: 1px solid $secondFontColor;
        border-radius: 6px;
        height: 45px;
        width: 100%;
        transition: all 0.5s ease-in-out;

        p {
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: $secondFontColor;
          margin-right: 12px;
          transition: all 0.5s ease-in-out;
        }

        svg {
          path {
            transition: all 0.5s ease-in-out;
          }
        }
      }
    }

    &:hover {
      box-shadow: 0px 0px 44px rgba(0, 166, 93, 0.25);

      .image-container-hover {
        opacity: 0.8;
      }

      .content-button {
        background-color: $activeColor;
        border-color: $activeColor;

        p {
          color: #ffffff;
        }

        svg {
          path {
            fill: #ffffff;
          }
        }
      }

      .content-ttl {
        color: $activeColor;
      }
    }
  }
}
</style>